import PropTypes from 'prop-types';

export const DrawerState = PropTypes.shape({
  isOpen: PropTypes.bool.isRequired,
  open: PropTypes.func,
  close: PropTypes.func,
  toggle: PropTypes.func
});
